import { desEncriptar } from "../../../utilidades/encriptacion";

export const filterMenuByPermissions = (menu) => {
    const dataClient = sessionStorage.getItem('dataClient');
    if (!dataClient) {
        console.warn('No hay datos de cliente en sessionStorage');
        return [];
    }
    
    const decrypted = desEncriptar(dataClient, process.env.REACT_APP_CLAVE_INCRIPTACION);
    if (!decrypted) {
        console.error('Error al desencriptar datos del cliente');
        return [];
    }
    
    let permissions;
    try {
        permissions = JSON.parse(decrypted).permissions;
    } catch (error) {
        console.error('Error al parsear permisos:', error);
        return [];
    }
    
    if (!permissions || !Array.isArray(permissions)) {
        console.warn('Permisos inválidos o vacíos');
        return [];
    }
    return menu.map(item => {
        const permisoItem = permissions.find(p => p.padre.toLowerCase() === item.title.toLowerCase());
        if (!permisoItem) {
            return null;
        }

        const filteredSubMenu = item.subMenu.filter(subItem =>
            permisoItem.modulos.some(modulo => modulo.nombre === subItem.title)
        );
        
        if (filteredSubMenu.length === 0) {
            return null;
        }

        return {
            ...item,
            subMenu: filteredSubMenu
        };
    }).filter(item => item !== null);
};